const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Accedi a più di 35 funzionalità premium di strumenti della suite completa, tra cui Potenziatore, Rimozione, Traduttore AI, Registratore Schermo e altro ancora, disponibili a un prezzo conveniente.',
  Upgrade: 'Aggiornamento',
  Tools: 'Strumenti',
  MyProjects: 'I Miei Progetti',
  MyAccount: 'Il Mio Conto',
  Subscription: 'Abbonamento',
  LogOut: 'Esci',
  PopularTools: 'Strumenti popolari',
  Enhance: 'Migliorare',
  Remove: 'Rimuovere',
  Animate: 'Animare',
  Extract: 'Estratto',
  SaveThreeDays:
    "I progetti vengono conservati per 3 giorni; si prega di scaricarli dopo l'elaborazione.",
  All: 'Tutto',
  Video: 'Video',
  Image: 'Immagine',
  Audio: 'Audio',
  minutesAgo: 'minuti fa',
  hoursAgo: 'ore fa',
  daysAgo: 'giorni fa',
  Modified: 'Modificato',
  Order: 'Ordine',
  EarliestToLatest: 'Dal più antico al più recente',
  LatestToEarliest: 'Dal più recente al più precoce',
  NoProject: 'Nessun progetto ancora. Inizio rapido con',
  OnlineTools: 'Strumenti online',
  AIVideoEnhancer: 'AI Ottimizzazione Video',
  Enhancer4K: "Con un clic l'AI migliora i video fino a 4K online",
  AIPhotoEnhancer: 'AI Ottimizzazione Foto',
  AIEnhancerImage:
    'AI migliora le immagini senza perdite fino a 8 volte online',
  View: 'Vista',
  Download: 'Download',
  MultipleSelect: 'Selezione multipla',
  Delete: 'Cancellare',
  SubscriptionHistory: 'Cronologia abbonamenti',
  NoValidSubscription: 'Nessun abbonamento valido.',
  veContent: "Con un clic l'AI migliora i video fino a 4K online",
  peContent:
    "L'intelligenza artificiale migliora le immagini senza perdite fino a 8 volte online",
  rmvContent: 'Rimuovi la filigrana dal video',
  rmttContent: "Rimuovi le filigrane dai video di TikTok in un batter d'occhio",
  dynamicContent: 'Anima la tua foto online',
  rmbgContent: "Rimuovi lo sfondo dall'immagine",
  youMayNeed: 'Potresti aver bisogno',
  new: 'Nuovo',
  loginYourAccount: 'Accedi al tuo account HitPaw',
  signUpYourAccount: 'Iscriviti al tuo account HitPaw',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
